const FarmExpense = {

    // FIELDS
    "farm": "Farm",
    "req_type": "Type",
    "date": "Date",
    "amount": "Amount",
    "notes": "Notes",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "farm_expense": "Farm Expense",

    // ERROR
    "error_farm": "Select Farm",
    "error_req_type": "Select Type",
    "error_date": "Choose Date",
    "error_amount": "Enter Amount",
    "error_amount_type_error": "Enter only positive number",
    "error_notes": "Enter Notes",

    // TABLE HEADER
    "table_farm": 'FARM',
    "table_req_type": 'TYPE',
    "table_date": 'DATE',
    "table_amount": 'AMOUNT',
    "table_status": "STATUS",

}

export default FarmExpense;